import { cheminFiche, cheminRubrique } from './chemins.js';
/**
 * Table des routes d'une langue. C'est la seule source de vérité : le sitemap,
 * le plan du site, la vérification des liens et l'écriture des fichiers en
 * découlent tous. Une page absente d'ici n'est ni écrite ni liée.
 */
export function routes(siteData, langue) {
    const liste = [];
    const rubrique = (r, vue, priorite) => {
        liste.push({ chemin: cheminRubrique(langue, r), langue, vue, rubrique: r, priorite });
    };
    const fiche = (r, slug, vue, priorite) => {
        liste.push({ chemin: cheminFiche(langue, r, slug), langue, vue, rubrique: r, slug, priorite });
    };
    rubrique('accueil', { type: 'accueil' }, 1);
    rubrique('artistes', { type: 'artistes' }, 0.8);
    for (const artiste of siteData.artistes) {
        fiche('artistes', artiste.slug, { type: 'artiste', slug: artiste.slug }, 0.7);
    }
    rubrique('expositions', { type: 'expositions' }, 0.8);
    for (const exposition of siteData.expositions.filter((e) => e.type === 'exposition')) {
        fiche('expositions', exposition.slug, { type: 'exposition', slug: exposition.slug }, 0.7);
    }
    const foires = siteData.expositions.filter((e) => e.type === 'foire');
    if (foires.length > 0) {
        rubrique('foires', { type: 'foires' }, 0.6);
        for (const foire of foires) {
            fiche('foires', foire.slug, { type: 'foire', slug: foire.slug }, 0.5);
        }
    }
    if (siteData.options.oeuvresDisponibles) {
        rubrique('oeuvres', { type: 'oeuvres' }, 0.8);
    }
    for (const oeuvre of siteData.oeuvres.filter((o) => o.visible)) {
        fiche('oeuvres', oeuvre.slug, { type: 'oeuvre', slug: oeuvre.slug }, 0.6);
    }
    rubrique('actualites', { type: 'actualites' }, 0.6);
    for (const actualite of siteData.actualites) {
        fiche('actualites', actualite.slug, { type: 'actualite', slug: actualite.slug }, 0.5);
    }
    rubrique('la-galerie', { type: 'la-galerie' }, 0.7);
    rubrique('contact', { type: 'contact' }, 0.7);
    rubrique('mentions', { type: 'mentions' }, 0.2);
    rubrique('confidentialite', { type: 'confidentialite' }, 0.2);
    rubrique('plan-du-site', { type: 'plan-du-site' }, 0.2);
    return liste;
}
/** Table des routes de toutes les langues actives, dans leur ordre déclaré. */
export function toutesLesRoutes(siteData) {
    return siteData.galerie.langues.actives.flatMap((langue) => routes(siteData, langue));
}
/** Résout un chemin en vue ; `introuvable` quand aucune route ne correspond. */
export function resoudre(siteData, langue, chemin) {
    const normalise = chemin.endsWith('/') ? chemin : `${chemin}/`;
    const route = routes(siteData, langue).find((r) => r.chemin === normalise);
    return route?.vue ?? { type: 'introuvable' };
}
//# sourceMappingURL=routes.js.map